import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CRMItem } from '../../models/crm/CRMItem.model';
import { CRMCompanyStormLabels } from '../../models/crm/CRMCompanyStorm';
import { CourtshipTypeLabels } from '../../enums/courtship-type.enum';
import { CRMStatusLabels, INVESTMENT_MADE_STATUSES } from '../../models/crm/CRMStatus';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ArchiveModalComponent } from '../../../modules/crm/crm-item/archive-modal/archive-modal.component';
import { BannerNotificationsService, PaginatedList, SpinnerService } from '../../../xform-compat';
import { CrmService } from '../../../core/data-services/crm.service';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CrmAlarmUtilsService } from '../../../core/data-services/crm-alarm-utils.service';
import { EventsHubService } from '../../../core/events-hub.service';
import { CrmStatusService } from '../../../core/data-services/crm-status.service';
import { CrmUtilsService } from '../../../core/data-services/crm-utils.service';
import { CrmNoteService } from '../../../core/data-services/crm-note.service';

@Component({
    selector: 'rms-crm-item-details',
    templateUrl: './crm-item-details.component.html',
    styleUrls: ['./crm-item-details.component.scss'],
    standalone: false
})
export class CrmItemDetailsComponent implements OnInit {

  @Input() crmItem: CRMItem;
  @Input() crmView: boolean;

  @Output() saveCrmItemEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() archiveCrmItemEvent: EventEmitter<any> = new EventEmitter<any>();

  public archivedItems: Array<CRMItem>;
  public archivedOpen: boolean;
  public silenceUntilVal = '-';
  public isOpen = false;

  public readonly statusLabels = CRMStatusLabels;
  public readonly courtshipLabels = CourtshipTypeLabels;
  public readonly stormLabels = CRMCompanyStormLabels;
  public readonly CRM_ITEM_ROUTE = '/sonar/item/';
  public readonly COMPANY_ROUTE = '/company/';

  private _origCrmItem;

  constructor(
    private crmService: CrmService,
    public crmUtilsService: CrmUtilsService,
    public crmNoteService: CrmNoteService,
    private crmAlarmUtilsService: CrmAlarmUtilsService,
    private spinnerService: SpinnerService,
    private bannerNotificationService: BannerNotificationsService,
    private router: Router,
    private modalService: NgbModal,
    private eventHubService: EventsHubService,
    public crmStatusService: CrmStatusService,
  ) {}

  ngOnInit() {
    this._origCrmItem = Object.assign({}, this.crmItem);
    this.getSilencedUntil();
  }

  public getParticipants(): string {
    return this.crmItem.participants.map(value => value.user.fullName).join(', ');
  }

  public getSilencedUntil() {
    const alarm = this.crmAlarmUtilsService.findSilenceAlarm(this.crmItem);
    if (alarm) {
      this.silenceUntilVal = alarm.trigger.value.substring(0, 10);
    } else {
      this.silenceUntilVal = '-';
    }
  }

  public editCrmItem() {
    this.eventHubService.openAddCrmModal({inputCrmItem: this.crmItem, editMode: true, onSave: (data) => {
      this.saveCrmItemEvent.emit(data);
      this.getSilencedUntil();
    }});
  }

  public openArchiveModal() {
    const modalRef = this.modalService.open(ArchiveModalComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.crmItem = this.crmItem;
    modalRef.result.then(data => {
      if (data) {
        this.archiveCrmItemEvent.emit(data);
      }
    });
  }

  public showArchived() {
    this.archivedOpen = true;
    this.loadArchivedItems();
  }

  public hideArchived() {
    this.archivedOpen = false;
  }

  public getDate(item: CRMItem): string {
    return new Date(item.created).toLocaleDateString();
  }

  public showSingleCrmNote(crm: CRMItem) {
    this.router.navigate([`sonar/item/${crm.id}`]);
  }

  public belowBreakpoint() {
    return document.documentElement.clientWidth < 768;
  }

  public openCrmHistory(crmItem: CRMItem) {
    window.open(`sonar/item/${crmItem.id}?audit=show`, '_blank');
  }

  private loadArchivedItems() {
    const params: any = {
      page: 0,
      pagesize: 10,
      sort: 'created',
      direction: 'ASC',
      ownerId: null,
      companyId: [this.crmItem.companies[0].company.id],
      domainId: null,
      status: null,
      courtshipType: null,
      storm: null,
      archived: true
    };
    this.spinnerService.start();
    this.crmService.getAllCrmItems(params)
      .pipe(map(data => this.processData(data)))
      .subscribe((data: PaginatedList<CRMItem>) => {
        this.archivedItems = data.records;
        this.spinnerService.stop();
      }, (error) => {
        this.bannerNotificationService.error(error);
        this.spinnerService.stop();
      });
  }

  private processData(data: PaginatedList<CRMItem>): PaginatedList<CRMItem> {
    data.records.forEach(d => d.notes.sort((a, b) => a.textContent.timestamp > b.textContent.timestamp ? -1 : 1));
    return data;
  }
}
